import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicBoothsAlgorithm = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="BOOTH'S ALGORITHM"
      videos={[
        "https://www.youtube.com/embed/7uWozW5kqfc", // Booth's Multiplication Algorithm
        "https://www.youtube.com/embed/db9-g_nnZSE", // Modified Booth's Algorithm
        "https://www.youtube.com/embed/SGnab30ISwg", // Modified Booth's Algorithm with Recoding
      ]}
      takeaways={[
        { text: "Booth's Multiplication Algorithm explains multiplication of signed 2’s complement numbers using bitwise operations." },
        { text: "- First video covers Booth's Algorithm with a detailed example." },
        { text: "Modified Booth's Algorithm optimizes multiplication by reducing the number of required addition/subtraction operations." },
        { text: "- Second video covers Modified Booth’s Algorithm with examples." },
        { text: "Booth's recoding method simplifies multiplication by converting the multiplier into a reduced form." },
        { text: "- Third video explains Booth’s recoding method with step-by-step examples." },
        { text: "Some teachers follow the flowchart method for Modified Booth, while others prefer Booth recoding (which is simpler and has fewer chances of mistakes)." },
        { text: "Learn how to calculate Booth recoded value for a 3-bit number (a previously asked question)." },
      ]}
      questions={[]} // Added empty array
      exampleVideos={[
    
      ]}
    />
);
}

export default ModuleSubtopicBoothsAlgorithm;
